import { render, staticRenderFns } from "./DataHistory.vue?vue&type=template&id=15d47739&scoped=true&"
import script from "./DataHistory.vue?vue&type=script&lang=ts&"
export * from "./DataHistory.vue?vue&type=script&lang=ts&"
import style0 from "./DataHistory.vue?vue&type=style&index=0&id=15d47739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d47739",
  null
  
)

export default component.exports